import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconResume(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M6 4C6 3.44772 5.55228 3 5 3C4.44772 3 4 3.44772 4 4V20C4 20.5523 4.44772 21 5 21C5.55228 21 6 20.5523 6 20V4Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.51523 3.12536C8.83319 2.94913 9.22173 2.95933 9.53 3.152L20.53 11.152C20.8224 11.3347 21 11.6552 21 12C21 12.3448 20.8224 12.6653 20.53 12.848L9.53 20.848C9.22173 21.0407 8.83319 21.0509 8.51523 20.8746C8.19728 20.6984 8 20.3635 8 20V4C8 3.63648 8.19728 3.30158 8.51523 3.12536ZM18.5 12L10 5.80425V18.1958L18.5 12Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
